import { createSlice } from '@reduxjs/toolkit'
const initialStateValues = {
    item: {
        redeemedItems:[],
        redeemedCategory:[],
        rewardedOrder:{isReward:false, reward_size: null ,search: null, name:null, isCategory:null,reward_id:null}
    },
    kidsComboItem: {
        isAllThreeItemAdded: false
    },
    LocationFlow:{
        isFlowActive: false,
        locationModalOpen: false,
        intendedPath: null
    },
    extras: {
        isAddPointSelected: false,
        rewardsHeaderClickCategory: null as string | null,
    },
    rewards: {
        validRewardsLength: null
    }
}

export const itemSlice = createSlice({
    name: 'item',
    initialState: initialStateValues,
    reducers: {
        updateRedeemedOrderContext: (state,action) =>{
            const {isReward, reward_size, search, name, isCategory,reward_id} = action.payload;
            state.item.rewardedOrder = {isReward, reward_size ,search, name, isCategory,reward_id}
        },
        updateAllItemAddedStateForKidsCombo: (state, action) => {
            const {allItemSelectionState} = action.payload;
            state.kidsComboItem.isAllThreeItemAdded= allItemSelectionState;
        },
        resetRedeemedOrderContex:(state) => {
            state.item.rewardedOrder = {isReward:false, reward_size: null ,search: null, name: null, isCategory:null,reward_id:null}
        },
        startLocationFlow : (state, action) => {
            state.LocationFlow.isFlowActive = true;
            state.LocationFlow.locationModalOpen = true;
            state.LocationFlow.intendedPath = action.payload;
        },
        startLocationFlowModalClose : (state) => {
            state.LocationFlow.locationModalOpen = false;
        },
        resetLocationFlow : (state) => {
            state.LocationFlow.isFlowActive = false;
            state.LocationFlow.locationModalOpen = false;
            state.LocationFlow.intendedPath = null;
        },
        resetRedeemedItemContext:(state) => {
            state.item.redeemedItems = [];
            state.item.redeemedCategory = [];
        },
        updateIsAddPointSelected:(state, action) => {
            state.extras.isAddPointSelected = action.payload
        },
        updateRewardsHeaderClickCategory:(state, action) => {
            state.extras.rewardsHeaderClickCategory = action.payload
        },
        updateValidRewardsLength:(state, action) => {
            state.rewards.validRewardsLength = action.payload
        },
    },
})

// Action creators are generated for each case reducer function
export const { resetRedeemedItemContext, updateRedeemedOrderContext, resetRedeemedOrderContex, updateAllItemAddedStateForKidsCombo, startLocationFlow, resetLocationFlow, startLocationFlowModalClose, updateIsAddPointSelected, updateRewardsHeaderClickCategory, updateValidRewardsLength } = itemSlice.actions


export const itemSliceReducer = itemSlice.reducer;

